import Marquee from "react-fast-marquee";
import { useContent } from "../../context/ContentContext";

export const ClientMarquee = () => {
  const { site } = useContent();
  const clients = site.clients || [];
  return (
    <div className="relative">
      <Marquee gradient gradientColor="#0D1B2A" gradientWidth={120} speed={40} pauseOnHover>
        {clients.map((name, i) => (
          <span
            key={i}
            data-testid={`client-logo-${i}`}
            className="mx-10 font-display text-2xl md:text-3xl font-medium uppercase tracking-tight text-white/40 transition-colors duration-300 hover:text-white"
          >
            {name}
          </span>
        ))}
      </Marquee>
    </div>
  );
};
